<template>
  <div class="mm_body">
    <mmheader :mm-site-url="mm_site_url"></mmheader>
    <div style="clear: both;"></div>
    <section class="container" style="padding-top: 72px !important;">
      <div class="row justify-content-center mb-3">
        <div class="col-md-5 col-xs-12">
          <div class="h5 mt-5 mb-4 text-center font-weight-bold">Edit Account Information</div>

          <div class="form-group">
            <input 
              type="text" 
              name="first name" 
              id="first_name" 
              ref="first_name"
              v-validate="{ rules: { required: true, regex: nameRegex() } }" 
              maxlength="250" 
              v-model="first_name"
              class="form-control" 
              placeholder="First Name">
            <div v-if="verrors.firstByRule('first name', 'required')" class="margin-bottom-5 validate-warning-msg">
              The first name field is required</div>
            <div v-if="verrors.firstByRule('first name', 'regex')" class="margin-bottom-5 validate-warning-msg">
              First name should only contain - and _</div>
          </div>

          <div class="form-group">
            <input 
              type="text" 
              name="last name" 
              id="last_name" 
              ref="last_name"
              v-validate="{ rules: { required: true, regex: nameRegex() } }" 
              maxlength="250" 
              v-model="last_name"
              class="form-control" 
              placeholder="Last Name">
            <div v-if="verrors.firstByRule('last name', 'required')" class="margin-bottom-5 validate-warning-msg">
              The last name field is required</div>
            <div v-if="verrors.firstByRule('last name', 'regex')" class="margin-bottom-5 validate-warning-msg">Last
              name should only contain - and _</div>
          </div>

          <div class="form-group">
            <div class="input-group">
              <input 
                type="text" 
                name="email" 
                id="email" 
                ref="email"
                v-validate="{ rules: { required: true, email: true } }" 
                maxlength="250" 
                v-model="email_edit"
                readonly
                class="form-control" 
                placeholder="Email"
                style="border-right:none;">
              <div class="input-group-append">
                <span class="input-group-text" style="background: #e9ecef;color: #00ACEE;">
                  <i class="fa fa-check-circle" aria-hidden="true"></i>
                </span>
              </div>
            </div>
            <div v-if="verrors.firstByRule('email', 'required')" class="margin-bottom-5 validate-warning-msg">The
              email field is required</div>
            <div v-if="verrors.firstByRule('email', 'email')" class="margin-bottom-5 validate-warning-msg">The email
              field must be a valid email</div>
          </div>

          <div class="form-group">
            <select 
              name="country"
              id="org_country"
              ref="org_country"                    
              v-model="org_country"
              v-validate="'required'" 
              v-on:change="getStateLists(org_country)"
              class="form-control">
                  <option v-for="(type, index) in country_options" :key="index" :value="type.value">{{ type.text }}</option>
              </select>
            <div v-show="verrors.has('country')" class="validate-warning-msg">{{ verrors.first('country') }}</div>
          </div> 

          <div class="form-group">
            <input 
              name="address" 
              id="org_address"
              ref="org_address"
              v-validate="'required'"
              maxlength="250" 
              v-model="org_address"
              class="form-control" 
              placeholder="Address 1">
            <div v-if="verrors.firstByRule('address', 'required')" class="margin-bottom-5 validate-warning-msg">The address 1 field is required</div>
          </div>

          <div class="form-group">
            <input 
              type="text" 
              name="mailing_address_2" 
              id="mailing_address_2"
              ref="mailing_address_2"
              v-model="mailing_address_2"
              class="form-control" 
              placeholder="Address 2"
              maxlength="250">
          </div>

          <div class="form-group">
            <input 
              type="text"
              name="city" 
              id="org_city"
              ref="org_city"
              v-validate="'required'"
              maxlength="100" 
              v-model="org_city" 
              class="form-control" 
              placeholder="City">
              <div v-show="verrors.has('city')" class="validate-warning-msg">{{ verrors.first('city') }}</div>
          </div>  

          <div class="form-group">
            <select 
              name="state" 
              id="org_state"
              ref="org_state"
              v-validate="'required'" 
              v-model="org_state" 
              class="form-control">
              <option v-for="(type, index) in state_options" :key="index" :value="type.value">{{ type.text }}</option>
            </select>
            <div v-if="verrors.firstByRule('state', 'required')" class="margin-bottom-5 validate-warning-msg">The state/province field is required</div>
          </div>                          

          <div class="form-group">
            <input 
              type="text" 
              name="zip" 
              id="org_zip"
              ref="org_zip"
              v-validate="{ rules: { required: true, regex: getPostalCodeRegex() } }"
              v-model="org_zip"
              maxlength="10"
              class="form-control" 
              placeholder="Zip/Postal Code">
            <div v-if="verrors.firstByRule('zip', 'required')" class="margin-bottom-5 validate-warning-msg">The zip/postal code field is required</div>
            <div v-if="verrors.firstByRule('zip', 'regex')" class="margin-bottom-5 validate-warning-msg">The zip/postal code format is invalid</div>
          </div> 

          <div class="text-center mt-3">
            <button type="submit" class="btn btn-lg btn-blue text-center px-5" @click="updateAccountInfo()">Save</button>
          </div>

        </div>
      </div>
    </section>
    <mmfooter :mm-site-url="mm_site_url"></mmfooter>
  </div>  
</template>

<script>
import axios from 'axios';
import mmheader from '@/components/mm_header';
import mmfooter from '@/components/mm_footer';

export default {
  data() {
    return {
      mm_site_url: process.env.MM_SITE_URL,
      first_name: '',
      last_name: '',
      email: '',
      email_edit: '',
      password: '',
      confirm_password: '',
      country_options: [],
      state_options: [],
      org_address: '',
      org_country: 'US',
      mailing_address_2: '',
      org_city: '',
      org_state: '',
      org_zip: '',
    }
  },
  components: {
    mmheader,
    mmfooter,
  },
  methods: {

    updateAccountInfo() {

      this.$validator.validateAll().then((result) => {
        if (!result) {
          console.log("ERROR" + result)
          return;
        }
        else {
            axios('/custom/update-account-info',
            {
                method: 'POST',
                data: {
                  'admin_fname': this.first_name,
                  'admin_lname': this.last_name,
                  'user_id': this.$store.state.create_account_uid,
                  'account_id': this.$store.state.create_account_accountId,
                  "address": this.org_address,
                  "country_code": this.org_country,
                  "state_code": this.org_state,
                  "city": this.org_city,
                  "zip": this.org_zip,
                  "address2": this.mailing_address_2
                },
            })
            .then(response => {  
              this.flash({ message: "Account information updated successfully!", variant: 'success' });              
              this.$router.push({ name: 'mmCreateAccountSubscriptionLists'})

            })
            .catch(error => {

            });

        }
        
      }).catch(() => {
        // catches the error;
      });
    },


    getPostalCodeRegex: function () {
      if (this.org_country == "US") {
        return /^[0-9]{5}(?:-[0-9]{4})?$/;
      } else if (this.org_country == "CA") {
        return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
      }
      return /./;
    },
    nameRegex: function () {
      return /^[a-zA-Z-_ ']*$/;
    },
    getCountryLists: function () {
      axios.get('/custom/account-create-country-lists', {})
        .then(response => {
          this.country_options = response.data;
        })
        .catch(function (error) {});
    },
    getStateLists: function (CountryCode) {
      this.org_state = '';
      if (CountryCode == '') {
        CountryCode = null;
      }
      axios.get('/custom/get-state-lists/' + CountryCode, {})
        .then(response => {
          response.data[0].text = "Select State / Province";
          this.state_options = response.data;
        })
        .catch(function (error) {});
    },
  },
  created() {
    this.getCountryLists();
      axios.get('/custom/get-account-user-details', {
        params: {
          account_id: this.$store.state.create_account_accountId,
          user_id: this.$store.state.create_account_uid,
        }
      })
      .then(response => {
        this.org_address = response.data.account_address;
        this.org_country = response.data.account_country;
        this.getStateLists(this.org_country);
        this.mailing_address_2 = response.data.account_address2;
        this.org_city = response.data.account_city;
        this.org_state = response.data.account_state;
        this.org_zip = response.data.account_zip;
        this.email_edit = response.data.primary_user_email;
        this.first_name = response.data.primary_user_fname;
        this.last_name = response.data.primary_user_lname;
      })
      .catch(function (error) {

      });

    
  },
}
</script>

<style scoped>
.mm_body {
  /* font-size: 20px !important; */
  color: #002F42;
  max-width: 2400px;
  margin: auto;
  font-family: "proxima-nova", Arial, verdana !important;
}
.btn-blue {
  font-size: 18px;
  padding: 2px 30px 2px 30px;
  border-radius: 5px;
}

</style>


// WEBPACK FOOTER //
// src/components/create_account/edit_subscription.vue